<template>
  <v-dialog v-model="open" :width="480" persistent scrollable>
    <v-card>
      <v-card-title class="headline">
        {{ value ? $t('edit_link') : $t('add_link') }}
      </v-card-title>
      <v-card-text>
        <v-form id="linkForm" @submit.prevent="handleSubmit">
          <div>
            <label :for="createId('name')" class="caption"
              >{{ $t('link_name') }} <span class="error--text">*</span></label
            >
            <v-text-field
              :id="createId('name')"
              v-model="form.name"
              v-validate="'required'"
              name="name"
              :data-vv-as="$t('link_name')"
              :error-messages="errors.collect('name')"
              :disabled="loading"
              outline
              single-line
            />
          </div>
          <div class="mt-2">
            <label :for="createId('liffId')" class="caption"
              >LIFF ID <span class="error--text">*</span></label
            >
            <v-text-field
              :id="createId('liffId')"
              v-model="form.liffId"
              v-validate="'required'"
              name="liffId"
              :data-vv-as="'LIFF ID'"
              :error-messages="errors.collect('liffId')"
              :disabled="loading"
              outline
              single-line
            />
          </div>
          <div class="mt-2">
            <label :for="createId('redirectUrl')" class="caption"
              >Redirect URL <span class="error--text">*</span></label
            >
            <v-text-field
              :id="createId('redirectUrl')"
              v-model="form.redirectUrl"
              v-validate="'required|url'"
              name="redirectUrl"
              :data-vv-as="'Redirect URL'"
              :error-messages="errors.collect('redirectUrl')"
              :disabled="loading"
              outline
              single-line
            />
          </div>
          <v-checkbox
            v-model="form.eventTracking.enabled"
            label="Event tracking"
            color="primary"
            :disabled="loading"
            hide-details
            class="mt-2 mb-0"
          />
          <template v-if="form.eventTracking.enabled">
            <div class="mt-2">
              <label :for="createId('eventCategory')" class="caption"
                >Event category <span class="error--text">*</span></label
              >
              <v-combobox
                :id="createId('eventCategory')"
                v-model="form.eventTracking.category"
                v-validate="'required'"
                name="eventCategory"
                :data-vv-as="'Event category'"
                :error-messages="errors.collect('eventCategory')"
                :disabled="loading"
                outline
                single-line
              />
            </div>
            <div class="mt-2">
              <label :for="createId('eventAction')" class="caption"
                >Event action <span class="error--text">*</span></label
              >
              <v-combobox
                :id="createId('eventAction')"
                v-model="form.eventTracking.action"
                v-validate="'required'"
                name="eventAction"
                :data-vv-as="'Event action'"
                :error-messages="errors.collect('eventAction')"
                :disabled="loading"
                outline
                single-line
              />
            </div>
            <div class="mt-2">
              <label :for="createId('eventValue')" class="caption"
                >Event value <span class="error--text">*</span></label
              >
              <v-text-field
                :id="createId('eventValue')"
                v-model="form.eventTracking.value"
                v-validate="'required'"
                name="eventValue"
                :data-vv-as="'Event value'"
                :error-messages="errors.collect('eventValue')"
                :disabled="loading"
                outline
                single-line
              />
            </div>
            <div class="mt-2">
              <label :for="createId('eventLabel')" class="caption"
                >Event label <span class="error--text">*</span></label
              >
              <v-combobox
                :id="createId('eventLabel')"
                v-model="form.eventTracking.label"
                v-validate="'required'"
                name="eventLabel"
                :data-vv-as="'Event label'"
                :error-messages="errors.collect('eventLabel')"
                :disabled="loading"
                outline
                single-line
              />
            </div>
          </template>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn :disabled="loading" @click="handleClose">{{ $t('cancel') }}</v-btn>
        <v-btn type="submit" form="linkForm" color="primary" :loading="loading">{{
          $t('Save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      open: false,
      form: {
        name: '',
        liffId: '',
        redirectUrl: '',
        eventTracking: {
          enabled: false,
          category: '',
          action: '',
          value: '',
          label: ''
        },
        ...this.value
      },
      loading: false
    }
  },
  mounted() {
    this.open = true
  },
  methods: {
    createId(value) {
      return `${value}-${this._uid}`
    },
    handleClose() {
      this.open = false
      setTimeout(() => {
        this.$emit('close')
      }, 300)
    },
    async handleSubmit() {
      const valid = await this.$validator.validate()
      if (!valid) return

      this.loading = true
      this.$emit('submit', this.form, (ok = true) => {
        if (!ok) {
          this.loading = false
          return
        }
        this.handleClose()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/my-allianz/LinkManagement/FormDialog.vue